import { EventsCounter } from './EventsCounter.js'
import { InvitationsCounter } from './InvitationsCounter.js'
import { MembersCounter } from './MembersCounter.js'
import { PostsCounter } from './PostsCounter.js'
import { SpacesCounter } from './SpacesCounter.js'
import { TagsCounter } from './TagsCounter.js'
import { TemplatesCounter } from './TemplatesCounter.js'
import type { TableHeaderCounterProps } from './types.js'

export const HeaderCounter = ({
  entityType,
  isLoading,
  matchedCount,
  totalCount,
}: TableHeaderCounterProps) => {
  if (!totalCount || isLoading) {
    return null
  }
  if (!Number.isFinite(totalCount) || !Number.isFinite(matchedCount)) {
    return null
  }

  switch (entityType) {
    case 'invitation':
      return (
        <InvitationsCounter
          matchedCount={matchedCount}
          totalCount={totalCount}
        />
      )
    case 'member':
      return (
        <MembersCounter matchedCount={matchedCount} totalCount={totalCount} />
      )
    case 'post':
      return (
        <PostsCounter matchedCount={matchedCount} totalCount={totalCount} />
      )
    case 'space':
      return (
        <SpacesCounter matchedCount={matchedCount} totalCount={totalCount} />
      )
    case 'tag':
      return <TagsCounter matchedCount={matchedCount} totalCount={totalCount} />
    case 'template':
      return (
        <TemplatesCounter matchedCount={matchedCount} totalCount={totalCount} />
      )
    case 'event':
      return (
        <EventsCounter matchedCount={matchedCount} totalCount={totalCount} />
      )
    case 'emailLog':
      return null

    default: {
      // This is an exhaustive check, hence bypassing the linter
      // eslint-disable-next-line unused-imports/no-unused-vars
      const _exhaustiveCheck: never = entityType

      throw new Error(
        `Table counter component does not support the ${entityType}. You need to add it to the list of countable entities and provide its counter component.`,
      )
    }
  }
}
